import { render, staticRenderFns } from "./digitalwallet.vue?vue&type=template&id=c97f6ca4&scoped=true&"
import script from "./digitalwallet.vue?vue&type=script&lang=js&"
export * from "./digitalwallet.vue?vue&type=script&lang=js&"
import style0 from "./digitalwallet.vue?vue&type=style&index=0&id=c97f6ca4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97f6ca4",
  null
  
)

export default component.exports